export default "__VITE_ASSET__BXRF3mVL__"